module.exports = "/media/outline-teeth-2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/tools/images/baby-teeth/outline-teeth-2.svg
// module id = 229
// module chunks = 0